import { render, staticRenderFns } from "./promo_menu.vue?vue&type=template&id=7ee639bb&vue3"
import script from "./promo_menu.vue?vue&type=script&lang=js&vue3"
export * from "./promo_menu.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports